var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 21,
    viewBox: "0 0 14 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_14435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.500001 19.9534V19.9523V1.07111C0.500099 1.06009 0.503184 1.04925 0.508987 1.03975C0.514755 1.03031 0.522962 1.02257 0.53278 1.01734C0.54288 1.0123 0.554227 1.01006 0.565615 1.01093C0.577005 1.0118 0.587892 1.01575 0.597119 1.02231C0.597279 1.02242 0.597438 1.02254 0.597597 1.02265L13.2695 10.3042V10.3133L13.4714 10.4633C13.4791 10.4691 13.4854 10.4765 13.4897 10.4851L13.9364 10.2604L13.4897 10.4851C13.494 10.4936 13.4962 10.503 13.4962 10.5126C13.4962 10.5221 13.494 10.5315 13.4897 10.5401C13.4855 10.5484 13.4795 10.5557 13.472 10.5614C13.4718 10.5616 13.4716 10.5617 13.4714 10.5619L0.595522 20.0012L0.594712 20.0018C0.584858 20.0091 0.573079 20.0133 0.56084 20.0139C0.550304 20.0133 0.539999 20.0108 0.530418 20.0065C0.521555 20.0013 0.514163 19.994 0.508884 19.9853L0.082267 20.2444L0.508881 19.9853C0.503058 19.9757 0.499977 19.9647 0.500001 19.9534ZM0.618871 18.8403V19.827L1.41454 19.2435L12.7888 10.9031L13.3388 10.4999L12.7888 10.0967L1.41447 1.75914L0.618871 1.17596V2.1624V18.8403Z",
    fill: "white",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_14435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/playIcon.96e3601131ca8d9f1fb567cbd35e53b1.svg";
export { ForwardRef as ReactComponent };